import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tasama/api-client-query';
import { I18nProvider, initI18n } from '@tasama/i18n';
import App from './App';
import { queryClient } from './core/config/api-config';
import { env } from '@tasama/config/onboarding';
import './index.css';

initI18n(env.I18N_COOKIE_DOMAIN || undefined);

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element not found');
}

const root = createRoot(container);

root.render(
  <I18nProvider>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </I18nProvider>
);
